export const isDev = import.meta.env.VITE_STAGE.trim() === 'dev';
export const isUat = import.meta.env.VITE_STAGE.trim() === 'uat';
export const isProduction = import.meta.env.VITE_STAGE.trim() === 'prod';
export const isProductionTest =
  import.meta.env.VITE_STAGE.trim() === 'prodtest';

export const INACTIVITY_LIMIT =
  Number(import.meta.env.VITE_INACTIVITY_LIMIT ?? 0) || 60 * 15;

export const INACTIVITY_POPUP_DURATION =
  Number(import.meta.env.VITE_INACTIVITY_POPUP_DURATION ?? 0) || 60;

export const API_BASE_URL = isProduction
  ? 'https://secureapi.clientpaydirect.com'
  : isProductionTest
  ? 'https://secureapi.clientpaydirect.com'
  : isUat
  ? 'https://api.uat.clientpaydirect.com'
  : isDev
  ? 'https://api.dev.clientpaydirect.com'
  : 'http://localhost:3003';
export const API_BASE_IMG_URL = API_BASE_URL + '/uploads/';
console.log(import.meta.env.VITE_STAGE);

export const PUBLIC_ASSETS_BASE_URL = isProduction
  ? 'https://assets.clientpaydirect.com/'
  : isUat
  ? 'https://assets.uat.clientpaydirect.com/'
  : isDev
  ? 'https://assets.dev.clientpaydirect.com/'
  : 'https://assets.dev.clientpaydirect.com/';

export const CLAIM_CLIENT_URL = isProduction
  ? 'https://claim.clientpaydirect.com'
  : isUat
  ? 'https://claim.uat.clientpaydirect.com'
  : isDev
  ? 'https://claim.dev.clientpaydirect.com'
  : 'http://localhost:5173';

export const NEW_CLAIM_CLIENT_URL = isProduction
  ? 'https://claim.tailfinpay.com'
  : isUat
  ? 'https://claim.uat.tailfinpay.com'
  : isDev
  ? 'https://claim-v2.dev.clientpaydirect.com'
  : 'http://localhost:5174';

export const CLIENT_URL = isProduction
  ? 'https://secure.clientpaydirect.com'
  : isUat
  ? 'https://uat.clientpaydirect.com'
  : isDev
  ? 'https://dev.clientpaydirect.com'
  : 'http://localhost:3000';

export const FACILITY_PORTAL_URL = isProduction
  ? 'https://portal.tailfinpay.com'
  : isProductionTest
  ? 'https://portal.tailfinpay.com'
  : isUat
  ? 'https://portal.uat.tailfinpay.com'
  : isDev
  ? 'https://portal.dev.tailfinpay.com'
  : 'http://localhost:5175';

export const RECAPTCHA_KEY = isProduction
  ? '6LdfBz8pAAAAAJEbouVU4BZAzjxJ1OvOIFYvWGD2'
  : isUat
  ? '6LfiqTgpAAAAAKZ6VHQCoIxfO4SbSOI42a6oRA6H'
  : '6LesEzgpAAAAAOS6xK9u6FeOhPMOnhREyVVYtuEk';

export const POSTHOG_KEY = isProduction
  ? 'phc_ml7OWfCHOjAKLq0GS5VZJf5KpkDRfVbYEw8qimGGPM3'
  : 'phc_QRHAJcnkHfh6t9OAm24REasop1DzT5SfYyZhdjjptGv';

export const SENTRY_DSN =
  'https://9bb55d74e4afac747c25ff472830c93b@o4510313204482048.ingest.us.sentry.io/4510363514241024';

export const POSTHOG_HOST =
  import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com';

export const DATADOG_APPLICATION_ID = 'f583a6a1-646f-4749-a2bb-680c0af2ea4e';
export const DATADOG_CLIENT_TOKEN = 'pubec2bbed62212ecb948777cf26b9893d0';
export const DATADOG_SITE = 'datadoghq.com';
export const DATADOG_RUM_ENABLED =
  import.meta.env.VITE_DATADOG_RUM_ENABLED === 'true';
export const DATADOG_PRIVACY_LEVEL =
  import.meta.env.VITE_DATADOG_PRIVACY_LEVEL || 'mask';
export const datadogRumEnabled = Boolean(
  DATADOG_RUM_ENABLED && DATADOG_APPLICATION_ID && DATADOG_CLIENT_TOKEN,
);
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;

export const defaultLetterTemplate = {
  name: 'Dear {{first_name}} {{last_name}}, ',
  date: 'Date {{date}}',

  line1:
    'Due to an identified overpayment for recent medical procedures, we are writing to inform you that {{facility_name}} owes you a refund in the amount of ${{refund_amount}}',
  line2:
    '{{facility_name}} uses our services to reach out to refunds like you and make getting your refunds easier.',
  line3: `To claim your refund:

  1.    Please visit {{claim_url}} and enter {{unique_code}}
  
  OR
  
  2.    Email us at hello@clientpaydirect.com and have your unique code of {{unique_code}} available to reference.`,
  disclaimer: `Please do not share this code with anyone outside of ClientPay Direct or {{facility_name}}. This is a unique code for you to claim your refund.
Please note that this code will be valid for 60 days after this letter has been sent. Please feel free to email us with any questions or concerns.`,

  signature: `Thank you.
Client Pay Direct
hello@clientpaydirect.com`,

  logo: null,
  logoPreview: null,
};

export const bankNames = Object.freeze({
  JPMORGAN: 'jpmorgan',
  CAPITAL_ONE: 'capitalone',
  BOA: 'BOA',
  First_Fed_Bank: 'First Fed Bank',
  Wells_Fargo: 'Wells Fargo',
  RBC: 'RBC',
});
